import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseComponent } from '../base/base-component.component';
import { ThemeSkin } from '../services/theme.service';

export enum ButtonType {
  Regular,
  Flat,
  Link,
}

export enum ButtonAlignement {
  Start,
  End,
}
export enum ButtonAttractive {
  None = 0,
  Regular = 1,
  Heavy = 2,
}

export enum ButtonIcon {
  None = 0,
  Add,
  AddComment,
  Edit,
  View,
  Save,
  Delete,
  Upload,
  Download,
  Library,
  Search,
  FilterInActive,
  FilterActive,
  BookmarkActive,
  BookmarkInActive,
  Debug,
  Message,
  Previous,
  Next,
  FullScreenEnter,
  FullScreenExit,
  History,
  Hide,
  More,
  Collapse,
  Expand,
  ExpandAll,
  CollapseAll,
  Link,
  Duplicate,
  ExternalLink,
  SetAsDefault,
  Reject,
  Indent,
  Outdent,
  OrderedList,
  Quiz,
  UnorderedList,
  Undo,
  Redo,
  Switch,
  ZoomReset,
  Reset,
  Modules,
  ModulesAdd,
  Scan,
  Share,
}

@Component({
  standalone: false,
  selector: 'daui-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./button.component.less'],
})
export class ButtonComponent extends BaseComponent {
  @Input() type: ButtonType = ButtonType.Regular;
  @Input() alignement: ButtonAlignement = ButtonAlignement.Start;
  @Input() attractive: ButtonAttractive = ButtonAttractive.None;
  @Input() skin: ThemeSkin = ThemeSkin.Default;
  @Input() icon: ButtonIcon = ButtonIcon.None;
  @Input() disabled = false;

  readonly buttonType = ButtonType;
  readonly buttonAlignement = ButtonAlignement;
  readonly buttonAttractive = ButtonAttractive;
  readonly themeSkin = ThemeSkin;
  readonly buttonIcon = ButtonIcon;

  constructor() {
    super();
  }

  protected onInit(): void {}

  protected onDestroy(): void {}

  onClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
}
